<template>
  <div class="app flex-row align-items-center">

  </div>
</template>

<script>
  export default {
    name: 'Logout',
    components: {
    },
    data () {
      return {
      }
    },
    methods: {
    },
    created: function () {
      this.$auth.logout()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/Logout.vue